export default __webpack_public_path__ + "static/media/Akzidenz-GroteskCondensed.f495fa4e.woff2";